<div v-if="enableCorners" class="matrix_optionsTable matrix_table">
  <div class="matrix_tableHeader">{{ $t("Corners") }}</div>
  <div class="sidebar_popup">
    <div class="cornersContainer">
      <div v-for="corner  in getCornersh" :class="'corner '+ corner.type ">
        <div class="cornerArea">
          <label :class="{switch:true,isActive:corner.isActive}">
            <input type="checkbox" v-model="corner.isActive" />
            <span class="slider round"></span>
            <span class="active status">{{ $t('AN') }}</span>
            <span class="inactive status">{{$t('AUS') }}</span>
          </label>
        </div>
        <div class="cornerArea">
          <div
            class="radiusArea"
            v-show="corner.subItems[corner.subItemIndex].type=='circle' || corner.subItems[corner.subItemIndex].type=='circle2'"
          >
            <span>{{$t('R') }}</span>
            <input
              v-model.number="corner.x"
              type="text"
              :id="'radius_'+corner.type"
              v-on:keydown.enter="onEnter"
            />
          </div>
          <div
            class="coordonatesArea"
            v-show="corner.subItems[corner.subItemIndex].type=='line'"
          >
            <div class="x-container">
              <span>{{$t('X') }}</span>
              <input
                type="text"
                v-model.number="corner.x"
                :id="'x_'+corner.type"
                  v-on:keydown.enter="onEnter"
              />
            </div>
            <div class="y-container">
              <span>{{$t('Y') }}</span>
              <input
                v-model.number="corner.y"
                type="text"
                :id="'y_'+corner.type"
                  v-on:keydown.enter="onEnter"
              />
            </div>
          </div>
        </div>
        <div class="cornerArea">
          <div
            v-for="(subItem,index)  in corner.subItems"
            :class="{cornerImg:true ,isActive:corner.subItemIndex ==index}"
          >
            <img
              v-bind:src="subItem.image_url"
              @click="changeActiveItem($event,corner.type,index)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
